import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { redirect } from 'common/actions';

import { setPsychSelectedCandidate } from './actions/setPsychSelectedCandidate';
import './PsychometricList.css';

const ListItem = (props) => {
  const history = useHistory();

  const { candidate } = props;
  const { flags } = candidate;
  const { donePsychAssessment } = flags;

  const handleClickStart = () => {
    props.setPsychSelectedCandidate(candidate);
    props.redirect(`/psychometric/assessment`);
  };

  const handleClickViewPassport = () => {
    history.push(`/passport/${candidate.id}/3`);
  };

  return (
    <div className="step">
      <div className="badge">1</div>
      <div className="card">
        {donePsychAssessment ? (
          <>
            <p className="cardTitle">
              Psychometric evaluation{' '}
              <span className="pill pill--green">completed</span>
            </p>
            <p className="cardBody">
              Thanks for completing this step. You can view your results any time
              from your passport.
            </p>
            <button
              type="button"
              className="startBtn"
              onClick={handleClickViewPassport}
            >
              View Passport
            </button>
          </>
        ) : (
          <>
            <p className="cardTitle">
              Psychometric evaluation{' '}
              <span className="pill pill--grey">optional</span>
            </p>
            <p className="cardBody">
              A short set of questions about your working style and preferences.
              There&apos;s no pass or fail — just answer honestly so we can
              understand how you work best.
            </p>
            <button type="button" className="startBtn" onClick={handleClickStart}>
              Start
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const WrappedListItem = connect(null, { redirect, setPsychSelectedCandidate })(
  ListItem,
);

const TechnicalStep = (props) => {
  const history = useHistory();

  const { candidate } = props;
  const { flags } = candidate;
  const { doneTechAssessment, enablePassport } = flags;

  const handleClickViewPassport = () => {
    history.push(`/passport/${candidate.id}`);
  };

  return (
    <div className="step">
      <div className="badge">2</div>
      <div className="card">
        {doneTechAssessment ? (
          enablePassport ? (
            <>
              <p className="cardTitle">
                Technical assessment{' '}
                <span className="pill pill--green">completed</span>
              </p>
              <p className="cardBody">
                Thanks for completing this step. You can view your results any
                time from your passport.
              </p>
              <button
                type="button"
                className="startBtn"
                onClick={handleClickViewPassport}
              >
                View Passport
              </button>
            </>
          ) : (
            <>
              <p className="cardTitle">
                Technical assessment{' '}
                <span className="pill pill--green">completed</span>
              </p>
              <p className="cardBody">
                Thanks for completing this step. Your results have been submitted
                and are awaiting approval — your passport will be available once
                that&apos;s done.
              </p>
            </>
          )
        ) : (
          <>
            <p className="cardTitle">
              Technical assessment <span className="pill">check your email</span>
            </p>
            <p className="cardBody">
              You&apos;ll receive a secure invite by email from our proctoring
              partner (ProctorExam) — follow the link there to start. Complete it
              in up to <strong>3 sittings across 3 hours total</strong>, and use{' '}
              <strong>&apos;End session&apos;</strong> to pause and resume later.
            </p>
            <p className="cardHint">
              Can&apos;t find it? Check your spam folder or contact{' '}
              <a href="mailto:contact@competas.com">contact@competas.com</a>.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const PsychometricList = (props) => {
  const { candidates } = props;

  return (
    <div className="nextSteps">
      <h2 className="heading">Your next steps</h2>
      {candidates.length === 0 ? (
        <p className="empty">No evaluations assigned yet.</p>
      ) : (
        <div className="timeline">
          {candidates.map((e) => (
            <React.Fragment key={`steps-${e.id}`}>
              <WrappedListItem candidate={e} />
              <TechnicalStep candidate={e} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

PsychometricList.propTypes = {
  candidates: PropTypes.array.isRequired,
};

export default PsychometricList;
